<template>
  <div id="main">
    <Title>Manage your account</Title>
    <UserDetailsForm />
    <PasswordChangeForm />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserDetailsForm from "@/components/UserDetailsForm.vue";
import PasswordChangeForm from "@/components/PasswordChangeForm.vue";

export default {
  name: "UserAccount",
  components: { UserDetailsForm, PasswordChangeForm },
  computed: {
    ...mapGetters("accounts", ["currentUser"])
  }
};
</script>
<style scoped>
#main {
  max-width: 600px;
}
</style>
